import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '@global/utils/tailwind'

const PageIcon = ({ children }) => {
  return <div className="flex items-center ml-8">{children}</div>
}

const ManagerTitle = ({ children }) => {
  return <h2 className="text-sm font-sans text-cv-blue-400 uppercase font-medium">{children}</h2>
}

const Title = ({ children }) => {
  return <h1 className="text-2xl font-sans mb-1 text-cv-blue-700">{children}</h1>
}

const Subtitle = ({ children }) => {
  return <h2 className="text-sm font-sans text-cv-blue-400">{children}</h2>
}

const Pill = ({ children }) => {
  return (
    <div className="text-[11px] font-semibold text-cv-blue-400 px-[8px] py-[5px] bg-cv-blue-50 border border-cv-blue-200 rounded-xl">
      {children}
    </div>
  )
}

interface NavItem {
  path: string
  label: string
  selected: boolean
}

interface AdminHeaderProps {
  nav?: NavItem[]
  children: ReactNode
}

export const AdminHeader = ({ nav = [], children }: AdminHeaderProps) => {
  return (
    <header className="flex flex-col flex-1 pt-[10px] pb-[20px] bg-white border-b border-cv-blue-200">
      <div className="flex flex-row">{children}</div>
      {nav.length > 0 ? (
        <nav className="flex ml-8 relative bottom-[-20px]">
          <ul className="m-0 p-0 flex">
            {nav.map(item => (
              <li
                key={item.label.toLowerCase().split(' ').join('-')}
                className="flex mr-[20px] text-[12px]"
              >
                <Link
                  to={item.path}
                  className={cn(
                    'flex items-center py-[5px] w-full cursor-pointer',
                    'border-transparent border-b-[3px]',
                    item.selected ? 'border-cv-green-400' : '',
                  )}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ) : null}
    </header>
  )
}

AdminHeader.PageIcon = PageIcon
AdminHeader.ManagerTitle = ManagerTitle
AdminHeader.Title = Title
AdminHeader.Subtitle = Subtitle
AdminHeader.Pill = Pill
